import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Invited site role "viewer" cannot open Insights (dashboards / agile charts). */
export const insightsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isSiteViewer()) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};
